import type { AssetType } from '../types/valuation';

export const generateAssetTypes = (): AssetType[] => [
  {
    "id": 1,
    "name": "Passion Investments (Other)"
  },
  {
    "id": 2,
    "name": "Bank Account"
  },
  {
    "id": 3,
    "name": "Property"
  },
  {
    "id": 4,
    "name": "Market Traded Security"
  },
  {
    "id": 5,
    "name": "ETF"
  },
  {
    "id": 6,
    "name": "Managed Fund"
  },
  {
    "id": 7,
    "name": "Portfolio"
  },
  {
    "id": 8,
    "name": "Super/Pension Portfolio"
  },
  {
    "id": 9,
    "name": "Corporate Bond"
  },
  {
    "id": 10,
    "name": "Government Bond"
  },
  {
    "id": 11,
    "name": "Other Asset"
  },
  {
    "id": 12,
    "name": "Term Deposit"
  },
  {
    "id": 13,
    "name": "Other Fixed Interest"
  },
  {
    "id": 14,
    "name": "Bank Loan"
  },
  {
    "id": 15,
    "name": "Insurance"
  },
  {
    "id": 17,
    "name": "Annuity"
  },
  {
    "id": 18,
    "name": "Passion Investments (Motor Vehicles)"
  },
  {
    "id": 19,
    "name": "Passion Investments (Jewellery)"
  },
  {
    "id": 20,
    "name": "Passion Investments (Watches)"
  },
  {
    "id": 21,
    "name": "Passion Investments (Artwork)"
  },
  {
    "id": 22,
    "name": "Passion Investments (Household Items)"
  },
  {
    "id": 23,
    "name": "Passion Investments (Boats)"
  },
  {
    "id": 24,
    "name": "Passion Investments (Aircraft)"
  },
  {
    "id": 25,
    "name": "Passion Investments (Bags)"
  },
  {
    "id": 26,
    "name": "Crypto Wallet"
  },
  {
    "id": 27,
    "name": "Crypto Coin"
  },
  {
    "id": 28,
    "name": "Credit Card"
  },
  {
    "id": 29,
    "name": "Commodities (Metals and Industrials)"
  },
  {
    "id": 30,
    "name": "Commodities (Agricultural)"
  },
  {
    "id": 31,
    "name": "Commodities (Energy)"
  },
  {
    "id": 32,
    "name": "Passion Investments (Books, Folios and Manuscripts)"
  },
  {
    "id": 33,
    "name": "Passion Investments (Coins, Medallions and Bank Notes)"
  },
  {
    "id": 34,
    "name": "Passion Investments (Wines and Spirits)"
  },
  {
    "id": 35,
    "name": "Passion Investments (Memorabilia)"
  },
  {
    "id": 36,
    "name": "Passion Investments (Antiques and Artefacts)"
  },
  {
    "id": 37,
    "name": "Passion Investments (Sentimental Non-Monetary)"
  },
  {
    "id": 38,
    "name": "Other Liability"
  },
  {
    "id": 39,
    "name": "Private Company"
  },
  {
    "id": 40,
    "name": "Passion Investments (Digital Assets)"
  },
  {
    "id": 41,
    "name": "Collection"
  },
  {
    "id": 42,
    "name": "Passion Investments (Audio Devices)"
  },
  {
    "id": 43,
    "name": "Passion Investments (Livestock)"
  },
  {
    "id": 44,
    "name": "Passion Investments (Multimedia)"
  },
  {
    "id": 45,
    "name": "Passion Investments (Musical Instruments)"
  },
  {
    "id": 46,
    "name": "Plant and Equipment"
  },
  {
    "id": 47,
    "name": "Uncategorised"
  },
  {
    "id": 48,
    "name": "Passion Investments (Shoes)"
  },
  {
    "id": 49,
    "name": "Passion Investments (Clothes)"
  },
  {
    "id": 50,
    "name": "Passion Investments (Sporting Equipment)"
  }
];